<template>
  <div class="agency-info" data-test-id="AgencyInfoComponent">
    <p v-if="selectedEmsAgency" data-test-id="AgencyItem">{{ selectedEmsAgency.name }} {{ additionalText }}</p>
    <p v-else data-test-id="NoAgencyItem">Please select an EMS Agency</p>
  </div>
</template>

<script>
export default {
  name: "AgencyInfo",

  props: {
    additionalText: {
      default: "",
      type: String
    },
    selectedEmsAgency: {
      default: () => {},
      type: Object
    }
  }
};
</script>

<style>
.agency-info {
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;
  text-align: center;
}
.agency-info > p {
  font-size: 2.5rem;
}
@media only screen and (max-width: 768px) {
  .agency-info {
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
  .agency-info > p {
    font-size: 1.5rem;
  }
}
</style>
